import React, {useCallback} from 'react';
import {PromptButton} from 'shared/PromptButton';
import type {TableButton, TableRowType} from 'shared/types';
import {getActionLabel} from './helpers';

export const JobCardPromptButton = ({
    button,
    row,
}: {
    button: TableButton;
    row: TableRowType;
}) => {
    const handleAction = useCallback(
        (event: React.MouseEvent) => button.action?.(row, event),
        [button, row]
    );

    const isDanger = button.title === 'Delete Job';

    return (
        <PromptButton
            title={button.title}
            iconName={button.iconName}
            disabled={
                typeof button.disabled === 'function'
                    ? button.disabled(row)
                    : button.disabled
            }
            action={handleAction}
            showConfirmation={!!button.confirmChanges}
            className={`job-card-action${isDanger ? ' job-card-action-danger' : ''}`}>
            {getActionLabel(button.title)}
        </PromptButton>
    );
};
